(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-discount-ladder"] && !Shopify.designMode) return;
  try {
    class CartDiscountLadder extends HTMLElement {
    connectedCallback() {
      this.tiers = this.parseTiers();
      this.moneyFormat = this.dataset.moneyFormat || "";
      this.tmplNext = this.dataset.tmplNext || "";
      this.tmplMax = this.dataset.tmplMax || "";
      this.tmplSaving = this.dataset.tmplSaving || "";
      this.tmplLocked = this.dataset.tmplLocked || "";

      this.messageEl = this.querySelector("[data-ladder-message]");
      this.fillEl = this.querySelector("[data-ladder-fill]");
      this.pillEl = this.querySelector("[data-ladder-pill]");
      this.rungs = Array.prototype.slice.call(
        this.querySelectorAll("[data-tier-min]")
      );

      this.onCart = this.onCart.bind(this);
      this.bindEvents();
      this.fetchCart();
    }

    disconnectedCallback() {
      this.unbindEvents();
    }

    parseTiers() {
      try {
        return JSON.parse(this.dataset.tiers || "[]").sort(function (a, b) {
          return a.min - b.min;
        });
      } catch (e) {
        return [];
      }
    }

    bindEvents() {
      if (window.jQuery) {
        this.$body = window.jQuery(document.body);
        this.$body.on(
          "afterCartLoad.ajaxCart afterAddItem.ajaxCart afterChangeItem.ajaxCart",
          this.onCart
        );
      }
      document.addEventListener("cart:updated", this.onCart);
      document.addEventListener("cart:refresh", this.onCart);
      document.addEventListener("ajaxProduct:added", this.onCart);
    }

    unbindEvents() {
      if (this.$body) {
        this.$body.off(
          "afterCartLoad.ajaxCart afterAddItem.ajaxCart afterChangeItem.ajaxCart",
          this.onCart
        );
      }
      document.removeEventListener("cart:updated", this.onCart);
      document.removeEventListener("cart:refresh", this.onCart);
      document.removeEventListener("ajaxProduct:added", this.onCart);
    }

    onCart() {
      this.fetchCart();
    }

    fetchCart() {
      var self = this;
      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (cart) {
          if (cart) {
            self.render(cart);
          }
        })
        .catch(function () {});
    }

    render(cart) {
      var base =
        typeof cart.items_subtotal_price === "number"
          ? cart.items_subtotal_price
          : (cart.total_price || 0) + (cart.total_discount || 0);

      var tiers = this.tiers;
      if (!tiers.length || !cart.item_count) {
        this.setAttribute("hidden", "");
        return;
      }
      this.removeAttribute("hidden");

      var current = null;
      var next = null;
      for (var i = 0; i < tiers.length; i++) {
        if (base >= tiers[i].min) {
          current = tiers[i];
        } else if (!next) {
          next = tiers[i];
        }
      }

      this.rungs.forEach(function (li) {
        var min = parseInt(li.getAttribute("data-tier-min"), 10);
        li.classList.toggle("is-on", base >= min);
      });

      if (this.messageEl) {
        if (current && next) {
          this.messageEl.textContent = this.tmplNext
            .replace("[pct]", current.pct)
            .replace("[amount]", this.formatMoney(next.min - base))
            .replace("[next_pct]", next.pct);
        } else if (current) {
          this.messageEl.textContent = this.tmplMax.replace("[pct]", current.pct);
        } else if (next) {
          this.messageEl.textContent = this.tmplLocked
            .replace("[amount]", this.formatMoney(next.min - base))
            .replace("[pct]", next.pct);
        } else {
          this.messageEl.textContent = "";
        }
      }

      if (this.pillEl) {
        if (current) {
          var savings = Math.round((base * current.pct) / 100);
          this.pillEl.textContent = this.tmplSaving.replace(
            "[amount]",
            this.formatMoney(savings)
          );
          this.pillEl.removeAttribute("hidden");
        } else {
          this.pillEl.setAttribute("hidden", "");
        }
      }

      if (this.fillEl) {
        var last = tiers[tiers.length - 1].min;
        var pct = 0;
        if (base >= last) {
          pct = 100;
        } else if (base > 0) {
          pct = (base / last) * 100;
        }
        this.fillEl.style.width = Math.max(0, Math.min(100, pct)) + "%";
      }
    }

    formatMoney(cents) {
      if (
        window.Shopify &&
        typeof window.Shopify.formatMoney === "function" &&
        this.moneyFormat
      ) {
        return window.Shopify.formatMoney(cents, this.moneyFormat);
      }
      return "$" + (cents / 100).toFixed(2);
    }
  }

  if (!customElements.get("cart-discount-ladder")) {
    customElements.define("cart-discount-ladder", CartDiscountLadder);
  }
  } catch(e) { console.error(e); }
})();

})();
